import styled from '@emotion/styled';

import { DESKTOP } from '@/styles/themes';
import { fontGmarketSans } from '@/styles/themes/variables';

export const Title = styled.h2`
  font-size: 18px;
  color: #e4e4e4;
  margin: 0 0 16px;
  ${DESKTOP} {
    font-size: 24px;
  }
`;

export const CardWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  div:nth-of-type(1) {
    width: 180px;
    div {
      div {
        top: 10px;
      }
    }
  }
  div:nth-of-type(2) {
    width: calc(100% - 180px - 12px);
    div {
      div {
        top: 13px;
      }
    }
  }
  div:nth-of-type(3) {
    width: 160px;
    div {
      div {
        top: 16px;
      }
    }
  }
  div:nth-of-type(4) {
    width: calc(100% - 160px - 12px);
    div {
      div {
        top: 10px;
      }
    }
  }
  ${DESKTOP} {
    justify-content: space-between;
    gap: 0;
    div:nth-of-type(1) {
      width: 300px;
      div {
        div {
          top: 9px;
        }
      }
    }
    div:nth-of-type(2) {
      width: 200px;
      div {
        div {
          top: 12px;
        }
      }
    }
    div:nth-of-type(3) {
      width: 220px;
      div {
        div {
          top: 18px;
        }
      }
    }
    div:nth-of-type(4) {
      width: 220px;
      div {
        div {
          top: 8px;
        }
      }
    }
  }
`;

export const Card = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 100px;
  background-color: #2b2c2f;
  border-radius: 4px;
  ${DESKTOP} {
    height: 148px;
    font-size: 18px;
  }
`;

export const CardText = styled.div`
  margin-left: 16px;
  font-size: 14px;
  letter-spacing: -1.6px;
  text-align: left;
  color: #e4e4e4;
  ${DESKTOP} {
    font-size: 18px;
    margin-left: 20px;
  }
`;

export const CardImg = styled.div`
  position: absolute;
  width: 45px !important;
  right: 0;
  ${DESKTOP} {
    width: 76px !important;
  }
`;

export const CardData = styled.span`
  font-family: ${fontGmarketSans};
  display: block;
  font-weight: 700;
  font-size: 28px;
  color: #ff3333;
  margin-top: 6px;
  ${DESKTOP} {
    font-size: 40px;
  }
`;
